// External Business/Management Dashboard (shabzclosetdash.in) — the single source of
// truth for management reporting. We link out to it (new tab) so the Billing session
// stays intact. Partner store-visibility is passed as a hint query param; the external
// dashboard remains unchanged and may honour it if/when supported.
export const DASHBOARD_URL = 'https://shabzclosetdash.in';

export const dashboardUrlFor = (user) => {
  const scope = user?.dashboard_scope;
  if (scope && scope !== 'all') {
    return `${DASHBOARD_URL}/?store=${encodeURIComponent(scope)}`;
  }
  return DASHBOARD_URL;
};

export const openDashboard = (user) => {
  const url = dashboardUrlFor(user);
  // New tab/window where supported; noopener for security.
  window.open(url, '_blank', 'noopener,noreferrer');
};
